import { nextPage, previousPage, registerRecommendationsSlotPagination, selectPage, setPageSize, } from './pagination-actions.js';
import { paginationReducer as commercePagination } from './pagination-slice.js';
/**
 * Loads the commerce pagination reducer and returns the available pagination action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the pagination action creators.
 *
 * @group Actions
 * @category Pagination
 */
export function loadPaginationActions(engine) {
    engine.addReducers({ commercePagination });
    return {
        registerRecommendationsSlotPagination,
        setPageSize,
        selectPage,
        nextPage,
        previousPage,
    };
}
